import { useCallback, useContext, useEffect, useState } from "react";
import "./Navbar.css";
import { FaUser, FaCog } from "react-icons/fa";
import { MdSearch, MdOutlineLogin } from "react-icons/md";
import { HiXMark } from "react-icons/hi2";
import Bach from "../../../public/wireless.svg";
import { NavLink, Link } from "react-router-dom";
import { AppContext } from "../../Context/AppContext";
import { IoIosPerson } from "react-icons/io";
import { FaUserAlt } from "react-icons/fa";
import { RiArrowDownSFill, RiLogoutBoxRLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import dolat_img from "../../../public/dolar.svg";
import { RiLuggageDepositFill } from "react-icons/ri";

import {
  loginSuccess,
  logout,
  revertUser,
  updateAvailableBalance,
  updateExposureBalance,
} from "../../../../AsianExchangeSrc/redux/slices/userSlice";
import MobileBets from "../MobileBets/MobileBets";
import {
  createLoginRecord,
  fetchuserdata,
  getCurrentRecord,
  login,
  ReCallCasinoBalance,
} from "../../../../AsianExchangeSrc/api";
import {
  revertAccount,
  setAccountType,
} from "../../../../AsianExchangeSrc/redux/slices/accountSlice";
import {
  isSignupUser,
  newSky,
  selectSiteDomainName,
  selectSiteFevicon,
  selectSiteHeaderColor,
  selectSiteLoginColor,
  selectSiteLogo,
  selectSiteName,
  selectSiteTopHeaderColor,
} from "../../../../AsianExchangeSrc/utils/helper/commonSelectors";
import { generatePresignedUrl } from "../../../../AsianExchangeSrc/utils/helper/generatePresignedUrl";
import { persistor } from "../../../../AsianExchangeSrc/redux/store";
import { RotateCw, Settings } from "lucide-react";
import FinancialButtonsmb from "../FinancialButtonsmb";
import MobileSettings from "../MobileSettings/MobileSettings";

const Navbar = () => {
  const navigate = useNavigate();
  const { setLoginOpen } = useContext(AppContext);
  const [menu, setMenu] = useState(false);
  const userData = useSelector((state) => state?.user?.userData);
  const userIs = useSelector((state) => state.user);
  const [error, setError] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [number, setNumber] = useState("");
  const dispatch = useDispatch();
  const [isLoadingBalance, setIsLoadingBalance] = useState(false);
  const SiteName = useSelector(selectSiteDomainName());
  const userId = userData?._id;
  const accountType = useSelector((state) => state?.account?.accountType) || "";
  const signupUser = useSelector(isSignupUser());
  

  const fetchBalanceData = useCallback(async () => {
    if (!userId) return;
    setIsLoadingBalance(true);
    try {
      const res = await fetchuserdata(userId);
      if (res?.success) {
        dispatch(updateAvailableBalance(res?.data?.userdata?.availableBalance));
        dispatch(updateExposureBalance(res?.data?.userdata?.exposure));
      }
    } catch (error) {
      console.error("Error fetching balance data:", error);
      toast.error("Failed to fetch balance");
    } finally {
      setIsLoadingBalance(false);
    }
  }, [userId, dispatch]);

  const handleToggle = () => {
    setMenu(!menu);
  };

  const generateNumber = () => {
    const randomNum = Math.floor(1000 + Math.random() * 9000);
    setNumber(randomNum.toString());
  };

  useEffect(() => {
    generateNumber();
  }, []);

  const [formData, setFormData] = useState({
    userName: "",
    password: "",
    x_panel_type: "user",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    try {
      setIsLoading(true);
      if (!inputValue) {
        toast.error("Validation code is empty");
        return;
      }

      if (inputValue !== number) {
        toast.error("Invalid validation code!");
        generateNumber();
        return;
      }

      const response = await login(formData);

      if (!response?.data) {
        throw new Error("No response data");
      }

      const { token, userdata, success } = response.data;

      if (success) {
        localStorage.setItem("userId", userdata?._id);

        dispatch(
          loginSuccess({
            userData: userdata,
            loggedInType: "real",
            token: token,
          })
        );

        dispatch(
          setAccountType({
            userData: userdata,
            type: "real",
          })
        );

        toast.success("Login Success");
        const res = await getCurrentRecord();
        await createLoginRecord(res.data);
      } else {
        throw new Error("Login failed");
      }
    } catch (error) {
      const errorMessage = error.message || "Login failed. Please try again.";
      toast.error(errorMessage);
      setError(errorMessage);
      console.error("Login error:", error);
      generateNumber();
    } finally {
      setIsLoading(false);
    }
  };

  const LoginModal = () => {
    setLoginOpen(true);
  };

  const handleLogout = (event) => {
    event.preventDefault();
    dispatch(revertUser());
    dispatch(revertAccount());
    localStorage.clear();
    persistor.purge();
    window.location.href = "/";
  };

  const [openSide, setOpenSide] = useState("");
  const [openSideSetting, setOpenSideSetting] = useState("");

  const handleClick = () => {
    setOpenSide("bet-side-open");
  };
  const handleClickSetting = () => {
    setOpenSideSetting("bet-side-open");
  };

  const { matches: cricketMatches } = useSelector(
    (state) => state.matches.cricket
  );
  const { matches: soccerMatches } = useSelector(
    (state) => state.matches.soccer
  );
  const { matches: tennisMatches } = useSelector(
    (state) => state.matches.tennis
  );

  const filterInplayMatches = (matches) => {
    return (
      matches?.data?.filter((e) =>
        e?.matchOdds?.some((odds) => odds?.inplay)
      ) || []
    );
  };

  const filteredCricketMatches = filterInplayMatches(cricketMatches);
  const filteredSoccerMatches = filterInplayMatches(soccerMatches);
  const filteredTennisMatches = filterInplayMatches(tennisMatches);

  const [logo, setLogo] = useState("");
  const [favIcon, setFavIcon] = useState("");

  const siteLogo = useSelector(selectSiteLogo());
  const sitefavIcon = useSelector(selectSiteFevicon());
  const siteName = useSelector(selectSiteName());

  console.log({siteName});
  

  const HeaderColor = useSelector(selectSiteHeaderColor());
  const TopHeaderColor = useSelector(selectSiteTopHeaderColor());
  const LoginBtnColor = useSelector(selectSiteLoginColor());
  const SkyDesign = useSelector(newSky());
  const handlereCall = async (e) => {
    e.preventDefault();
    console.log(userData?.casinoBalance);
    try {
      const response = await ReCallCasinoBalance({
        CasinoBalance: userData?.casinoBalance,
      });
      toast.success(response.data.message);
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error occurred";
      toast.error(errorMessage);
    }
  };
  useEffect(() => {
    let isMounted = true;
    const fetchLogo = async () => {
      try {
        if (siteLogo && sitefavIcon) {
          const presignedUrl = await generatePresignedUrl(siteLogo);
          const presignedFevUrl = await generatePresignedUrl(sitefavIcon);
          if (isMounted) {
            setLogo(presignedUrl);
            setFavIcon(presignedFevUrl);
          }

          if (siteName && isMounted) {
            document.title = DOMPurify.sanitize(siteName);
          }
        }
      } catch (error) {
        console.error("Error fetching logos or favicons:", error);
      }
    };

    if (siteLogo || sitefavIcon || siteName) {
      fetchLogo();
    }

    return () => {
      isMounted = false;
    };
  }, [siteLogo, sitefavIcon, siteName]);

  const accountMenuItems = [
    { to: "/myAccount/profile", text: "My Profile" },
    { to: "/myAccount/summary", text: "Balance Overview" },
    { to: "/myAccount/accountCashStatement", text: "Account Statement" },
    { to: "/myAccount/current_bets", text: "My Bets" },
    { to: "/myAccount/bets-history", text: "Bets History" },
    { to: "/myAccount/profit-loss", text: "Profit & Loss" },
    { to: "/myAccount/bank-transfer", text: "Bank Transfer" },
    { to: "/myAccount/activityLog", text: "Active Log" },
  ];

  return (
    <div className="navbar navbar-sky">
      {/* Top Navbar */}
      <div
        className="navbar-top"
        style={{
          backgroundImage: `linear-gradient(${SkyDesign === "true" ? "90deg" : "180deg"
            }, ${HeaderColor?.start}, ${HeaderColor?.end})`,
        }}
      >
        <div className={`logo_search_box ${userId ? `user-logged-in` : ""}`}>
          <div className="navbar-logo">
            <Link to="/">
              <img src={logo || ""} alt="Logo" className="logo" />
            </Link>
          </div>

          <div className="search-bar">
            <MdSearch className="search-icon" />
            <input type="text" placeholder="Search Events" />
            <div className="search-close">
              <HiXMark className="close-icon" />
            </div>
          </div>
        </div>

        {userId ? (
          <>
          
          <div className="account-wrap">
            <div className="main-wallet flex">
              {siteName == "Blacklion Club" && signupUser && (
                <div
                  className="bg-[#ffb80c] text-[black] px-2 mr-3 text-[12px] rounded cursor-pointer font-bold flex justify-center items-center"
                  onClick={() => navigate("/balance-overview")}
                >
                  Deposit
                </div>
              )}


              {siteName !== "Blacklion Club" && signupUser && (
                <>
                  <div
                    className="bg-[#15803d] text-[black] px-2 mr-3 text-[12px] rounded cursor-pointer font-bold flex justify-center items-center"
                    onClick={() => navigate("/balance-overview")}
                  >
                    Deposit
                  </div>
                  <div
                    className="bg-[#910707] text-[white] px-2 mr-3 text-[12px] rounded cursor-pointer font-bold flex justify-center items-center"
                    onClick={() => navigate("/withdraw")}
                  >
                    Withdrawal
                  </div>
                </>
              )}

              <a href="#">
                Main Balance{" "}
                <b style={{ marginLeft: "4px", marginRight: "4px" }}>
                  INR{" "}
                  {Math.floor(
                    (userData?.availableBalance || 0) -
                    Number(userData?.exposure || 0)
                  )}
                </b>{" "}
                Exposure{" "}
                <b style={{ marginLeft: "4px", marginRight: "4px" }}>
                  {Math.floor(userData?.exposure || 0)}
                </b>
                <span>
                  +<b>4</b>
                </span>
              </a>
              <button
                onClick={accountType === "real" ? fetchBalanceData : null}
              >
                <RotateCw
                  size={12}
                  className={`text-yellow-100 mx-auto ${isLoadingBalance ? "animate-spin" : ""
                    }`}
                />
              </button>
            </div>

            <div className="my-account">
              <button onClick={handleToggle}>
                <FaUserAlt /> My Account <RiArrowDownSFill />
                {menu && (
                  <div className="my-account-doropdown">
                    <ul>
                      <h4>
                        {userData?.userName}
                        <span className="sp2">GMT+5:30</span>
                      </h4>
                      {accountMenuItems.map((item, index) => (
                        <li key={index}>
                          <Link to={item.to}>{item.text}</Link>
                        </li>
                      ))}
                      <li className="Casino-btn">
                        <p>Casino Balance</p>
                        <div className="flex gap-2">
                          <button
                            onClick={handlereCall}
                            className=" flex gap-2 items-center p-1 bg-[#2789ce] text-[white] rounded-md"
                          >
                            Recall
                            <span>
                              {userData?.casinoBalance?.toFixed(0) || ""}
                            </span>
                          </button>
                        </div>                        </li>
                      <div className="logout-btn" onClick={handleLogout}>
                        LOGOUT <RiLogoutBoxRLine />
                      </div>
                    </ul>
                  </div>
                )}
              </button>
            </div>
          </div>
          </>
          
        ) : (
          <div className="auth-container">
            <div className="user-section">
              <FaUser className="user-icon" />
              <input
                type="text"
                placeholder="Username"
                className="auth-input"
                name="userName"
                value={formData.userName}
                onChange={handleChange}
              />
            </div>
            <input
              type="password"
              placeholder="Password"
              className="auth-input"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />

            <div className="validation">
              <input
                type="text"
                placeholder="Validation"
                className="auth-input"
                value={inputValue}
                onChange={handleInputChange}
              />
              <span className="validation-number">{number}</span>
            </div>

            <button
              className={`auth-btn login-btn`}
              onClick={handleLogin}
              disabled={isLoading}
              style={{
                background:
                  SkyDesign === "true"
                    ? "red"
                    : `linear-gradient(180deg, ${LoginBtnColor?.start}, ${LoginBtnColor?.end})`,
              }}
            >
              {isLoading ? (
                <>
                  Login... <span className="spinner" />
                </>
              ) : (
                <>
                  Login <MdOutlineLogin />
                </>
              )}
            </button>

            <Link to="/signUp">
              <button
                className={`auth-btn ${SkyDesign === "true" ? "bg-[#FF0000]" : "signup-btn"
                  }`}
              >
                Sign Up
              </button>
            </Link>
          </div>
        )}

        <div className={`mobile-auth-btn ${userId ? `user-logged-in` : ""}`}>
          <Link to="/signUp">Sign up</Link>
          <Link to="/Login">
            <IoIosPerson className="w-6 h-6" />
            Login
          </Link>
        </div>

        {/* logged in section */}
        <ul className={`li-tv_bet-main ${userId ? `user-logged-in` : ""}`}>
          {SkyDesign === "true" ? (
            <div className="navbar-logo">
              <Link to="/">
                <img src={logo || ""} alt="Logo" className="logo" />
              </Link>
            </div>
          ) : (
            <li className="li-tv_bet" onClick={handleClick}>
              <img src={dolat_img} alt="Bets" />
              Bets
              </li>
              
          )}

          <div className="main-wallet main-wallet-mobile flex">
            {signupUser && siteName == "Blacklion Club" && (
              <div className="main-wallet main-wallet-mobile flex mr-1">
                <Link to={"/balance-overview"} className="!p-0">
                  <div className="px-1 flex items-center justify-center flex-col">
                    <RiLuggageDepositFill />
                    <b>DEPOSIT</b>
                  </div>
                </Link>
              </div>
            )}

            <a>
              <div className="px-1.5">
                <div>
                  Main
                  <b style={{ marginRight: "4px" }}>
                    INR{" "}
                    {Math.floor(
                      (userData?.availableBalance || 0) -
                      Number(userData?.exposure || 0)
                    )}
                  </b>
                </div>
                <div>
                  Exposure{" "}
                  <b style={{ marginRight: "4px", color:"#bb0000" }}>
                    {Math.floor(userData?.exposure || 0)}
                  </b>
                </div>
              </div>
              <button onClick={fetchBalanceData}>
                <RotateCw
                  size={12}
                  className={`text-yellow-100 mx-auto ${isLoadingBalance ? "animate-spin" : ""
                    }`}
                />
              </button>
            </a>
            <div className="main-wallet main-wallet-mobile ml-2">
                <Link className="!ml-0 !pl-0 w-12 flex justify-center">
                 
                <p onClick={handleClickSetting}>
                  <Settings size={18}/>
                 </p>
                </Link>
              </div>
          </div>
        </ul>
        {/* logged in section */}
      </div>

      {/* Bottom Navbar */}
      <div
        className="navbar-bottom"
        style={{
          backgroundImage: `linear-gradient(180deg, ${TopHeaderColor?.start}, ${TopHeaderColor?.end})`,
        }}
      >
        <ul className="navbar-menu">
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          <li>
            <NavLink to="/in-play">In-Play</NavLink>
          </li>
          <li>
            <NavLink to="/multi-markets">Multi Markets</NavLink>
          </li>
          <li>
            <NavLink to="/cricket">
              Cricket
              <div className="badge">
                <strong className="bach-box">
                  <img src={Bach} alt="Badge" />
                </strong>
                <span className="badge-text">
                  {filteredCricketMatches?.length || 0}
                </span>
              </div>
            </NavLink>
          </li>
          <li>
            <NavLink to="/soccer">
              {SkyDesign === "true" ? "Football" : "Soccer"}
              <div className="badge">
                <strong className="bach-box">
                  <img src={Bach} alt="Badge" />
                </strong>
                <span className="badge-text">
                  {filteredSoccerMatches?.length || 0}
                </span>
              </div>
            </NavLink>
          </li>
          <li>
            <NavLink to="/tennis">
              Tennis
              <div className="badge">
                <strong className="bach-box">
                  <img src={Bach} alt="Badge" />
                </strong>
                <span className="badge-text">
                  {filteredTennisMatches?.length || 0}
                </span>
              </div>
            </NavLink>
          </li>
          <li>
            <NavLink to="/horse">
              Horse Racing
              <div className="badge">
                <strong className="bach-box">
                  <img src={Bach} alt="Badge" />
                </strong>
                <span className="badge-text">
                  {filteredTennisMatches?.length || 0}
                </span>
              </div>
            </NavLink>
          </li>
          <li>
            <NavLink to="/greyhound">
              Greyhound Racing
              <div className="badge">
                <strong className="bach-box">
                  <img src={Bach} alt="Badge" />
                </strong>
                <span className="badge-text">
                  {filteredTennisMatches?.length || 0}
                </span>
              </div>
            </NavLink>
          </li>
          {/* {userId ? (
            <li>
              <NavLink to="/virtual-cricket">Virtual Cricket</NavLink>
            </li>
          ) : (
            <li onClick={LoginModal}>
              <Link>Virtual Cricket</Link>
            </li>
          )} */}
          <li>
            <NavLink to="/casino-games/live-casino">Live Casino</NavLink>
          </li>
          {/* <li>
            <NavLink to="/kabaddi">
              Kabaddi
              <div className="badge">
                <strong className="bach-box">
                  <img src={Bach} alt="Badge" />
                </strong>
                <span className="badge-text">0</span>
              </div>
            </NavLink>
          </li> */}
          {userId &&
            [
              "d2.blacklion.club",
              "localhost:5174",
              "dubaibetclub.com",
            ].includes(SiteName) && (
              <li>
                <NavLink to="/referral">Referral</NavLink>
              </li>
            )}
        </ul>

        <div className="navbar-right">
          <span className="time-zone">
            Time Zone: <b style={{ color: "black" }}>GMT +5:30</b>
          </span>
          <span className="settings" onClick={handleClickSetting}>
            Setting <FaCog className="settings-icon" />
          </span>
        </div>
      </div>

      <MobileBets openSide={openSide} closeBets={() => setOpenSide("")} />
      <MobileSettings openSide={openSideSetting} closeBets={() => setOpenSideSetting("")} />
    </div>
  );
};

export default Navbar;
